import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseUrl from '../Config';


const AdminRegistrationForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    phoneNumber: '',
    designation: '',
    role: 'admin'
  });

  console.log('formData@@@@@@@@@' , formData)

  const [loading, setLoading] = useState(false);
  const [phoneError, setPhoneError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (value) => {
    setFormData((prev) => ({ ...prev, phoneNumber: value }));
    setPhoneError(!value ? 'Phone number is required' : '');
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      // Get token from sessionStorage (based on your ProtectedRoutes)
      const token = sessionStorage.getItem("token");
      
      const headers = {
        'Content-Type': 'application/json',
      };
      
      // Add authorization header if token exists
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      // Prepare data for backend (remove confirmPassword)
      const { confirmPassword, ...submitData } = formData;
      
      const res = await fetch(`${baseUrl}/signup`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(submitData),
      });
      
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || data.message || 'Registration failed');
      
      toast.success('Admin created successfully');
      setTimeout(() => navigate('/admin-list'), 1500);
    } catch (err) {
      console.log('Error:', err);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

   const validateForm = () => {
    if (!formData.name) return toast.error('Full name is required') || false;
    if (!formData.email) return toast.error('Email is required') || false;
    if (!formData.password) return toast.error('Password is required') || false;
    if (!formData.confirmPassword) return toast.error('Please confirm your password') || false;
    if (formData.password !== formData.confirmPassword) return toast.error('Passwords do not match') || false;
    if (formData.password.length < 6) return toast.error('Password must be at least 6 characters') || false;
    if (!formData.phoneNumber) return toast.error('Phone number is required') || false;
    if (!formData.designation) return toast.error('Designation is required') || false;
    return true;
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <ToastContainer position="top-right" autoClose={5000} />
      <div className="w-full max-w-[34rem] mt-12">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="relative bg-white pt-6 px-8 text-center border-b border-gray-100">
            <div className="mx-auto flex justify-center mb-4">
              <div className="p-3 bg-green-100 rounded-lg">
                <svg className="w-8 h-8 text-green-600" viewBox="0 0 24 24" fill="none">
                  <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                    stroke="currentColor" strokeWidth="1.5" />
                  <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22"
                    stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </div>
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-1">Create Admin Account</h1>
            <p className="text-gray-500">Get started with your admin dashboard</p>
            <div className="mt-6 mb-2">
              <div className="w-16 h-0.5 bg-green-500 mx-auto"></div>
            </div>
          </div>
          <div className="p-10">
            <form onSubmit={handleSubmit} className="space-y-8">
              <div className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                    Full Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition"
                    placeholder="John Doe"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    Email Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition"
                    placeholder="your@email.com"
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="relative">
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                      Password <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      required
                      minLength="6"
                      value={formData.password}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition pr-10"
                      placeholder="••••••••"
                    />
                    <button
                      type="button"
                      className="absolute right-3 top-9 text-gray-500 hover:text-gray-700"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                        </svg>
                      )}
                    </button>
                  </div>
                  <div className="relative">
                    <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1">
                      Confirm Password <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="confirmPassword"
                      name="confirmPassword"
                      type={showConfirmPassword ? "text" : "password"}
                      required
                      minLength="6"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition pr-10"
                      placeholder="••••••••"
                    />
                    <button
                      type="button"
                      className="absolute right-3 top-9 text-gray-500 hover:text-gray-700"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                      {showConfirmPassword ? (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>
                <div>
                  <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-1">
                    Role <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="role"
                    name="role"
                    required
                    value={formData.role}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition appearance-none bg-white"
                  >
                    <option value="admin">Admin</option>
                    <option value="manager">Manager</option>
                    <option value="staff">Staff</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="designation" className="block text-sm font-medium text-gray-700 mb-1">
                    Designation <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="designation"
                    name="designation"
                    type="text"
                    required
                    value={formData.designation}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition"
                    placeholder="Your position"
                  />
                </div>
                <div className="w-full flex flex-col gap-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Phone Number <span className="text-red-500">*</span>
                  </label>
                  <div className="flex items-center">
                    <PhoneInput
                      country={'in'}
                      value={formData.phoneNumber}
                      onChange={handlePhoneChange}
                      inputClass="!w-full !h-12 !rounded-lg !border-2 !border-gray-300 focus:!border-green-500"
                      buttonClass="!h-12 !bg-gray-50 !border-r !border-gray-300 !rounded-l-lg"
                      dropdownClass="!rounded-lg !mt-1"
                      containerClass="!w-full"
                      placeholder="Mobile Number *"
                    />
                  </div>
                  {phoneError && (
                    <p className="mt-1 text-sm text-red-600 text-center">{phoneError}</p>
                  )}
                </div>
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full mt-8 py-3 px-4 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg shadow transition duration-200 flex items-center justify-center text-lg"
              >
                {loading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Creating Account...
                  </>
                ) : (
                  'Register Now'
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminRegistrationForm;















// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/material.css';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const AdminRegistrationForm = () => {
//   const [formData, setFormData] = useState({
//     fullname: '',
//     email: '',
//     password: '',
//     confirmPassword: '',
//     phonenumber: '',
//     designation: '',
//     role: 'admin'
//   });
  
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [phoneError, setPhoneError] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const navigate = useNavigate();
  
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handlePhoneChange = (value) => {
//     setFormData({ ...formData, phonenumber: value });
//     if (!value) {
//       setPhoneError('Phone number is required');
//     } else {
//       setPhoneError('');
//     }
//   };

//   const validateForm = () => {
//     if (!formData.fullname) {
//       toast.error("Full name is required");
//       return false;
//     }
    
//     if (!formData.email) {
//       toast.error("Email is required");
//       return false;
//     }
    
//     if (!formData.password) {
//       toast.error("Password is required");
//       return false;
//     }
    
//     if (!formData.confirmPassword) {
//       toast.error("Please confirm your password");
//       return false;
//     }
    
//     if (formData.password !== formData.confirmPassword) {
//       toast.error("Passwords do not match");
//       return false;
//     }

//     if (formData.password.length < 6) {
//       toast.error("Password must be at least 6 characters");
//       return false;
//     }

//     if (!formData.phonenumber) {
//       toast.error("Phone number is required");
//       return false;
//     }
    
//     if (!formData.designation) {
//       toast.error("Designation is required");
//       return false;
//     }
    
//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validate all fields
//     if (!validateForm()) {
//       return;
//     }

//     try {
//       setLoading(true);
//       const res = await fetch('http://localhost:5000/api/auth/register', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });

//       const data = await res.json();

//       console.log('Registration Response:', data);

//       if (!res.ok) {
//         throw new Error(data.message || 'Registration failed');
//       }

//       toast.success('Admin created successfully');
//       setTimeout(() => navigate('/'), 2000);
//     } catch (err) {
//       toast.error(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
//       <ToastContainer position="top-right" autoClose={5000} />
//       <div className="w-full max-w-md">
//         <div className="bg-white rounded-xl shadow-md overflow-hidden">
//           {/* Header Section */}

//           <div className="relative bg-white pt-8 px-6 text-center border-b border-gray-100">
//   <div className="mx-auto flex justify-center mb-4">
//     <div className="p-3 bg-green-100 rounded-lg">
//       <svg className="w-8 h-8 text-green-600" viewBox="0 0 24 24" fill="none">
//         <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" 
//           stroke="currentColor" strokeWidth="1.5"/>
//         <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22" 
//           stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
//       </svg>
//     </div>
//   </div>
  
//   <h1 className="text-3xl font-bold text-gray-900 mb-1">Create Admin Account</h1>
//   <p className="text-gray-500">Get started with your admin dashboard</p>
  
//   <div className="mt-6 mb-2">
//     <div className="w-16 h-0.5 bg-green-500 mx-auto"></div>
//   </div>
// </div>

//           {/* Form Section */}
//           <div className="p-6 sm:p-8">
//             {error && (
//               <div className="mb-4 bg-red-50 border-l-4 border-red-500 p-4 rounded">
//                 <div className="flex items-center">
//                   <svg className="h-5 w-5 text-red-500 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                   </svg>
//                   <span className="text-red-700 text-sm">{error}</span>
//                 </div>
//               </div>
//             )}

//             <form onSubmit={handleSubmit} className="space-y-5">
//               <div className="space-y-4">
//                 {/* Full Name */}
//                 <div>
//                   <label htmlFor="fullname" className="block text-sm font-medium text-gray-700 mb-1">
//                     Full Name <span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     id="fullname"
//                     name="fullname"
//                     type="text"
//                     required
//                     value={formData.fullname}
//                     onChange={handleChange}
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition"
//                     placeholder="John Doe"
//                   />
//                 </div>

//                 {/* Email */}
//                 <div>
//                   <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
//                     Email Address <span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     id="email"
//                     name="email"
//                     type="email"
//                     required
//                     value={formData.email}
//                     onChange={handleChange}
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition"
//                     placeholder="your@email.com"
//                   />
//                 </div>

//                 {/* Password Fields */}

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//   <div className="relative">
//     <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
//       Password <span className="text-red-500">*</span>
//     </label>
//     <input
//       id="password"
//       name="password"
//       type={showPassword ? "text" : "password"}
//       required
//       minLength="6"
//       value={formData.password}
//       onChange={handleChange}
//       className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition pr-10"
//       placeholder="••••••••"
//     />
//     <button
//       type="button"
//       className="absolute right-3 top-9 text-gray-500 hover:text-gray-700"
//       onClick={() => setShowPassword(!showPassword)}
//     >
//       {showPassword ? (

//          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//         </svg>
      
//       ) : (
       


//   <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
//         </svg>
//       )}
//     </button>
//   </div>
//   <div className="relative">
//     <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1">
//       Confirm Password <span className="text-red-500">*</span>
//     </label>
//     <input
//       id="confirmPassword"
//       name="confirmPassword"
//       type={showConfirmPassword ? "text" : "password"}
//       required
//       minLength="6"
//       value={formData.confirmPassword}
//       onChange={handleChange}
//       className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition pr-10"
//       placeholder="••••••••"
//     />
//     <button
//       type="button"
//       className="absolute right-3 top-9 text-gray-500 hover:text-gray-700"
//       onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//     >
//       {showConfirmPassword ? (

//           <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//         </svg>       
//       ) : (
//        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
//         </svg>
//       )}
//     </button>
//   </div>
// </div>

//                 {/* Role */}
//                 <div>
//                   <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-1">
//                     Role <span className="text-red-500">*</span>
//                   </label>
//                   <select
//                     id="role"
//                     name="role"
//                     required
//                     value={formData.role}
//                     onChange={handleChange}
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition appearance-none bg-white"
//                   >
//                     <option value="admin">Admin</option>
//                     <option value="manager">Manager</option>
//                     <option value="staff">Staff</option>
//                   </select>
//                 </div>

//                 {/* Designation */}
//                 <div>
//                   <label htmlFor="designation" className="block text-sm font-medium text-gray-700 mb-1">
//                     Designation <span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     id="designation"
//                     name="designation"
//                     type="text"
//                     required
//                     value={formData.designation}
//                     onChange={handleChange}
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition"
//                     placeholder="Your position"
//                   />
//                 </div>

//                 {/* Phone Number */}
//                 <div className="w-full">
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Phone Number <span className="text-red-500">*</span>
//                   </label>
//                   <div className="relative">
//                     <PhoneInput
//                       country={'in'}
//                       value={formData.phonenumber}
//                       onChange={handlePhoneChange}
//                       inputClass={`w-full h-12 pl-14 !rounded-lg border-2 focus:outline-none focus:border-green-500 ${
//                         phoneError ? '!border-red-500' : '!border-green-200'
//                       }`}
//                       buttonClass="!h-11 !top-0.5 !left-0.5 !bg-gray-50 !border-r !border-gray-300 !rounded-l-lg"
//                       dropdownClass="!rounded-lg !mt-1"
//                       containerClass="!w-full"
//                       placeholder="Mobile Number *"
//                     />
//                   </div>
//                   {phoneError && (
//                     <p className="mt-1 text-sm text-red-600">{phoneError}</p>
//                   )}
//                 </div>
//               </div>

//               {/* Submit Button */}
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="w-full mt-6 py-3 px-4 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg shadow transition duration-200 flex items-center justify-center"
//               >
//                 {loading ? (
//                   <>
//                     <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                       <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                       <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                     </svg>
//                     Creating Account...
//                   </>
//                 ) : (
//                   'Register Now'
//                 )}
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminRegistrationForm;
